import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d92c3348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-end mt-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "SurveysForm",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createVNode(_component_the_input, {
      value: _ctx.state.title,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.title) = $event)),
      "is-invalid": _ctx.state_form$.title.$error,
      "validation-errors": _ctx.state_form$.title.$errors,
      disabled: _ctx.state.is_loading,
      placeholder: "Название опроса"
    }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
    _createVNode(_component_the_textarea, {
      class: "mt-3",
      placeholder: "Описание опроса",
      "is-invalid": _ctx.state_form$.description.$error,
      "validation-errors": _ctx.state_form$.description.$errors,
      value: _ctx.state.description,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.description) = $event)),
      rows: 5,
      maxlength: 255,
      disabled: _ctx.state.is_loading,
      autoheight: ""
    }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]),
    _createVNode(_component_checkbox, {
      class: "mt-3",
      value: _ctx.state.isActive,
      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.isActive) = $event)),
      label: "Активен",
      "return-integer": ""
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_button, {
        class: "small primary",
        loading: _ctx.state.is_loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.isUpdate ? 'Сохранить' : 'Создать'), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}